import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

import style from './style';

const Hero = ({ data }): any => {
  const classes = style();

  return (
    <Box className={classes.segment}>
      <Container disableGutters>
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <Typography variant="h6" color={'textSecondary'}>
              {data?.header}
            </Typography>
            <video autoPlay loop muted>
              <source
                src={
                  process.env.NEXT_PUBLIC_ASSETS + `/videos/${data?.videoLink}`
                }
              />
            </video>
          </Grid>
        </Grid>
      </Container>{' '}
    </Box>
  );
};

export default Hero;
